var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home" }, [
    _c("div", { staticClass: "banner" }, [
      _c(
        "div",
        {
          staticClass: "v-page-center div-center h-pct-100 flex-between-center",
        },
        [
          _c("div", { staticClass: "intro" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.banner.title)),
            ]),
            _c("div", { staticClass: "sub-title" }, [
              _vm._v(_vm._s(_vm.banner.subTitle)),
            ]),
            _c("div", { staticClass: "desc" }, [
              _vm._v(_vm._s(_vm.banner.desc)),
            ]),
            _c(
              "div",
              {
                staticClass: "btn text-center pointer",
                on: { click: _vm.useNow },
              },
              [_vm._v(_vm._s(_vm.banner.btnText))]
            ),
          ]),
          _c("div", { staticClass: "icon" }, [
            _c("img", { attrs: { src: _vm.banner.icon, alt: "banner_icon" } }),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "introduce relative" }, [
      _c("div", { staticClass: "v-page-center div-center" }, [
        _c(
          "div",
          { staticClass: "text-center base-card-title" },
          [
            _c("CardTitle", {
              attrs: {
                title: _vm.cardTitles.intro.title,
                letter: _vm.cardTitles.intro.letter,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-between-center" },
          _vm._l(_vm.introduces, function (intro) {
            return _c(
              "div",
              { key: intro.id, staticClass: "block text-center" },
              [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(intro.title)),
                ]),
                _c("div", { staticClass: "desc" }, [
                  _vm._v(_vm._s(intro.desc)),
                ]),
                _c("img", {
                  staticClass: "icon",
                  attrs: { src: intro.icon, alt: intro.title },
                }),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "workflow" }, [
      _c("div", { staticClass: "v-page-center div-center" }, [
        _c(
          "div",
          { staticClass: "text-center base-card-title" },
          [
            _c("CardTitle", {
              attrs: {
                title: _vm.cardTitles.workflow.title,
                letter: _vm.cardTitles.workflow.letter,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-between-center" },
          _vm._l(_vm.homeWorkflows, function (workflow) {
            return _c(
              "div",
              { key: workflow.id, staticClass: "workflow-item" },
              [
                _c("div", { staticClass: "workflow-item_info" }, [
                  _c(
                    "div",
                    { staticClass: "workflow-item_title flex-center" },
                    [
                      _c("img", {
                        attrs: { src: workflow.icon, alt: workflow.title },
                      }),
                      _c("div", [_vm._v(_vm._s(workflow.title))]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "flex-between-center" },
                    _vm._l(workflow.desc, function (text, idx) {
                      return _c(
                        "span",
                        { key: idx, staticClass: "workflow-item_desc" },
                        [_vm._v(_vm._s(text))]
                      )
                    }),
                    0
                  ),
                ]),
                _c("img", {
                  attrs: { src: workflow.thumbnail, alt: workflow.title },
                }),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "ai-agent" }, [
      _c("div", { staticClass: "v-page-center div-center" }, [
        _c(
          "div",
          { staticClass: "text-center base-card-title" },
          [
            _c("CardTitle", {
              attrs: {
                title: _vm.cardTitles.ai.title,
                letter: _vm.cardTitles.ai.letter,
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "flex-between-center" }, [
          _c(
            "div",
            { staticClass: "ai-agent-features flex-column flex-main-between" },
            _vm._l(_vm.aiAgents.features, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "ai-agent-features_item" },
                [
                  _c("img", { attrs: { src: item.icon, alt: "" } }),
                  _c(
                    "div",
                    { staticClass: "ai-agent-features_item_info" },
                    _vm._l(item.label, function (text, idx) {
                      return _c("div", { key: idx }, [_vm._v(_vm._s(text))])
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "ai-agent-agents flex-column" },
            _vm._l(_vm.aiAgents.agents, function (url) {
              return _c("img", { key: url, attrs: { src: url, alt: "" } })
            }),
            0
          ),
          _c("div", { staticClass: "ai-agent-thumbnail" }, [
            _c("img", { attrs: { src: _vm.aiAgents.thumbnail, alt: "" } }),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "intelligent-hardware" }, [
      _c("div", { staticClass: "v-page-center div-center" }, [
        _c(
          "div",
          { staticClass: "text-center base-card-title" },
          [
            _c("CardTitle", {
              attrs: {
                title: _vm.cardTitles.intelligence.title,
                letter: _vm.cardTitles.intelligence.letter,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex-between-center" },
          _vm._l(_vm.intelligences, function (item, index) {
            return _c(
              "div",
              { key: item.id, staticClass: "intelligent-hardware-item" },
              [
                _c("img", { attrs: { src: item.thumbnail, alt: item.title } }),
                _c(
                  "div",
                  {
                    staticClass: "intelligent-hardware-item_card",
                    class: [
                      index === 0
                        ? ["text-left", "style-left"]
                        : ["text-right", "style-right"],
                    ],
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "intelligent-hardware-item_card_title" },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _c(
                      "div",
                      { staticClass: "none" },
                      _vm._l(item.label, function (text, idx) {
                        return _c(
                          "div",
                          {
                            key: idx,
                            staticClass: "intelligent-hardware-item_card_label",
                          },
                          [_vm._v(" " + _vm._s(text) + " ")]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
    _c("div", { staticClass: "more-devices" }, [
      _c("div", { staticClass: "v-page-center div-center" }, [
        _c(
          "div",
          {
            staticClass: "text-center base-card-title",
            staticStyle: { "padding-bottom": "0" },
          },
          [
            _c("CardTitle", {
              attrs: {
                title: _vm.cardTitles.moreDevices.title,
                letter: _vm.cardTitles.moreDevices.letter,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "more-content flex-column flex-between-center" },
          [
            _c("div", { staticClass: "supplement" }, [
              _vm._v(_vm._s(_vm.cardTitles.moreDevices.subTitle)),
            ]),
            _c("div", { staticClass: "scroll-block scroll-x" }, [
              _c(
                "div",
                { staticClass: "scroll-container flex-side-center" },
                _vm._l(_vm.setAppSeamlessScroll, function (app) {
                  return _c(
                    "div",
                    {
                      key: app.id,
                      staticClass:
                        "scroll-item flex-column flex-between-center flex-auto",
                    },
                    [
                      _c("img", {
                        staticClass: "icon",
                        attrs: { src: app.icon, alt: app.label },
                      }),
                      _c("span", [_vm._v(_vm._s(app.label))]),
                      _c("span", { staticStyle: { "font-size": "12px" } }, [
                        _vm._v("品牌:  " + _vm._s(app.brand)),
                      ]),
                      app.hot
                        ? _c("img", {
                            staticClass: "tag",
                            attrs: {
                              src: require("@/assets/image/home/app-tag-hot.png"),
                              alt: "",
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "go-app-center flex-between-center pointer",
                on: { click: _vm.goAppCenter },
              },
              [
                _c("span", [_vm._v("前往应用中心")]),
                _c("img", {
                  staticClass: "flex-auto",
                  attrs: {
                    src: require("@/assets/image/home/icon_go.png"),
                    alt: "前往应用中心",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
    ]),
    _c("div", { staticClass: "use-us" }, [
      _c(
        "div",
        { staticClass: "v-page-center div-center h-pct-100 flex-end-center" },
        [
          _c(
            "div",
            {
              staticClass: "btn text-center pointer",
              on: { click: _vm.useNow },
            },
            [_vm._v(_vm._s(_vm.banner.btnText))]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }